"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Badges indicate to the user of additional information about an item they may be working on.
 * Unlike a notification, badges are not urgent and do not require immediate attention.
 * Badges differ from tags in that tags are either definitions that persist or originate from filtering and have more user involvement and control.
 *
 * @since 2.5.0
 */
var Badge = function Badge(_ref) {
  var children = _ref.children,
      classes = _ref.classes;
  return _react["default"].createElement("div", {
    className: classes.root
  }, children);
};

Badge.defaultProps = {
  type: 'default',
  classes: {
    root: ''
  }
};
Badge.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string.isRequired).isRequired,

  /** Children of Badge component */
  children: _propTypes["default"].node,

  /** Badge can be of 6 types - 'light', 'default', 'darker', 'darkest', 'error', 'warning' */
  type: _propTypes["default"].oneOf(['light', 'default', 'darker', 'darkest', 'error', 'warning'])
};

var _default = (0, _withStyles["default"])(_styles["default"])(Badge);

exports["default"] = _default;